import { funcState } from '../../utils/funcState';
import { Filters } from '../utils/filtersEnum';
import { defaultSort } from '../utils/sortOptions';

// Quick hack to get sorting "sorted" ;)
const SortProvider = ({ updateFilter }) => {
  const [sort, setSort] = funcState();
  const [sortOption, setSortOption] = funcState(defaultSort);

  const update = ({ queryParams }) => {
    const { sort: propSort, sortOption: propSortOption } = queryParams;

    try {
      setSort(JSON.parse(propSort));
    } catch {
      setSort(undefined);
    }

    setSortOption(propSortOption || defaultSort);

    updateFilter({
      key: Filters.Sort,
      value: {
        sort: JSON.stringify(sort.value),
        sortOption: sortOption.value,
      },
    });
  };

  const toQueryParams = () => ({
    sort: JSON.stringify(sort.value),
    sortOption: sortOption.value,
  });

  return { exposed: {}, update, toQueryParams };
};

export default SortProvider;
